export default [
  'Not interested.',
  'Insufficient Room Night volume to warrant a neg rate',
  'Our National Sales handles these accounts',
  'We are Temporarily Closed due to COVID',
  'We don\'t bid on Corporate Business',
  'We won\'t pay to bid on an RFP',
  'Our property is too far from this location',
  'Cost to bid is too high'
];